export default function() {
  controller('orders', self => {

    self.on('click', function() {
      $(this).closest('.js-orders-item').find('.js-orders-info').addClass('show');
    });

    $('.js-orders-checkbox').on('change', function() {
      if ( self.closest('.js-orders-item').find('.js-orders-checkbox').is(':checked') ) {
        $(this).closest('.js-orders-item').find('.js-orders-apply').removeClass('disable');
      } else {
        $(this).closest('.js-orders-item').find('.js-orders-apply').addClass('disable');
      }
    });

    $('.js-orders-cancel').on('click', function() {
      console.log('cancel');
      $(this).closest('.js-orders-item').find('.js-orders-info').removeClass('show');
    });

  });
}
